import Button from "../Button";
import {useContext} from "react";
import ForeignerAuthenticationContext from "../../tools/contexts/authenticatonService/ForeignerAuthenticationContext";

const ReportedCard=({reportedMessage,title})=>{
    const foreignerAuthenticationContext=useContext(ForeignerAuthenticationContext);
    const handleRedirect=()=>{
        const price=foreignerAuthenticationContext?.process?.payment?.info ? foreignerAuthenticationContext.process.payment.info.init_amount :0
        return foreignerAuthenticationContext.handleRedirectToDivar({price,status:"fail"})
    }
    return  <div className="flex flex-col items-center justify-center ">
        <div className="flex justify-center mt-10">
            <h1 className="text-3xl text-gray-600  ">
                ونیفای
            </h1>
        </div>
        <div className="p-5 mt-5  mx-2 flex w-11/12 md:w-6/12 lg:w-4/12 bg-white rounded-xl  flex-col items-center justify-center">
            <h1 className="font-bold mb-2 text-center">{title && title.length>0 ? title:"ناموفق"}</h1>
            <p className=" text-sm  text-center  ">{reportedMessage||"احراز هویت ناموفق بوده است."}</p>
            <div className="border-t w-full mt-3  pt-3">
                <Button theme="red" className="text-sm  w-full   " rounded="rounded-xl" onClick={handleRedirect}>بازگشت به دیوار </Button>
            </div>
        </div>
    </div>
}
export default ReportedCard;